import { put, takeEvery } from "redux-saga/effects";
import { ADD_TO_CART, ADD_TO_CART_LIST_DATA, REMOVE_CART_ITEM } from "../SagaAction/actions";
import requestApi from "../../utils/request";
import { addToCartFailure, addToCartListFailure, addToCartListRequest, addToCartListSuccess, addToCartRequest, addToCartSuccess, cartCount, removeCartItemFailure, removeCartItemRequest, removeCartItemSuccess } from "../Slices/AddToCartSlice";

function* addToCart(params) {
  try {
    yield put(addToCartRequest());
    const { meta } = yield requestApi.post("/add-cart", params?.payload);
    yield put(addToCartSuccess(meta));
    if (typeof params.callback === "function") {
      yield params.callback();
    }
  } catch (error) {
    yield put(addToCartFailure(error));
  }
}

function* addToCartListData(params) {
  try {
    yield put(addToCartListRequest());
    const {data,meta} = yield requestApi.post("/list-cart");
    yield put(addToCartListSuccess(data));
    yield put(cartCount(meta?.totalCount))
    if (typeof params.callback === "function") {
      yield params.callback();
    }
  } catch (error) {
    yield put(addToCartListFailure(error));
  }
}

function* removeCartItem(params) {
  try {
    yield put(removeCartItemRequest());
    const {data} = yield requestApi.post("/remove-cart",params.payload);
    yield put(removeCartItemSuccess());
    // yield put(cartCount(meta?.totalCount))
    if (typeof params.callback === "function") {
      yield params.callback();
    }
  } catch (error) {
    yield put(removeCartItemFailure(error));
  }
}


function* AddCartSaga() {
  yield takeEvery(ADD_TO_CART, addToCart);
  yield takeEvery(ADD_TO_CART_LIST_DATA, addToCartListData);
  yield takeEvery(REMOVE_CART_ITEM,removeCartItem)
}

export default AddCartSaga;
